export function getPropertyManagementPath(propertyId: string) {
  const searchParams = new URLSearchParams({
    propertyIds: propertyId,
    page: '0',
    pageSize: '10',
  });

  return `/marketing/google-hotel-ads-property-management?${searchParams.toString()}`;
}
